export default {
  name: 'B3'
}
